import { render } from "./TgProductCardComponent.vue?vue&type=template&id=3fdc79da&scoped=true"
import script from "./TgProductCardComponent.vue?vue&type=script&lang=js"
export * from "./TgProductCardComponent.vue?vue&type=script&lang=js"

import "./TgProductCardComponent.vue?vue&type=style&index=0&id=3fdc79da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fdc79da"]])

export default __exports__